// extracted by mini-css-extract-plugin
export default {"container":"SessionDetails_container__qjh4A","htmlCon":"SessionDetails_htmlCon__RNmjU","closeButton":"SessionDetails_closeButton__peHio","x":"SessionDetails_x__CRhyo"};